import classname from 'classnames/bind'
import { Text } from '@adc/ui-adc'
import { constants } from '@adc/ui-adc'
import seller_succes_icon_1 from '../../assets/seller_succes_icon_1.svg'
import seller_succes_icon_2 from '../../assets/seller_succes_icon_2.svg'
import seller_succes_icon_3 from '../../assets/seller_succes_icon_3.svg'
import styles from './styles.scss'

const { ColorNames } = constants
const cx = classname.bind(styles)
const SellerSuccess = () => {
  return (
    <div className={cx('success-section')}>
      <div className={cx('images-wrapper')}>
        <div className={cx('image-group')}>
          <div
            className={cx('circle-img')}
            style={{ backgroundImage: `url(${seller_succes_icon_1})` }}
          />
          <div
            className={cx('circle-img')}
            style={{ backgroundImage: `url(${seller_succes_icon_2})` }}
          />
          <div
            className={cx('circle-img')}
            style={{ backgroundImage: `url(${seller_succes_icon_3})` }}
          />
          <div className={cx('circle-img', 'badge')}>+2K</div>
        </div>
      </div>
      <Text
        style={{ lineHeight: '32px' }}
        className={cx('main-tex')}
        weight='medium'
        size='huge'
        as={'h2'}
        color={ColorNames.Action}
      >
        Thousands of sellers have successfully navigated pre-foreclosure <br />{' '}
        with Auction.com.
      </Text>
      <Text
        className={cx('sub-text')}
        color={ColorNames.Gray}
        size='large'
        weight='normal'
      >
        Join homeowners who found a path forward when they thought they were out
        of options.
      </Text>
    </div>
  )
}

export default SellerSuccess
